export type VariationDialogMessages = {
  // Dialog Titles
  deleteProductVariationDialogTitle: string;

  // Dialog Content Messages
  deleteProductVariationDialogContent: string;
  deleteProductVariationDialogCancel: string;
  deleteProductVariationDialogConfirm: string;
  deleteProductVariationSuccess: string;
};

export const VARIATION_DIALOG_MESSAGES: VariationDialogMessages = {
  // Dialog Titles
  deleteProductVariationDialogTitle: "Excluir Variação de Produto",

  // Dialog Content Messages
  deleteProductVariationDialogContent:
    "Tem certeza de que deseja excluir esta variação de produto?",
  deleteProductVariationDialogCancel: "Cancelar",
  deleteProductVariationDialogConfirm: "Confirmar",
  deleteProductVariationSuccess: "Variação de produto deletada com sucesso.",
};

export default VARIATION_DIALOG_MESSAGES;
